import {
  HttpRequest,
  apiUrl
} from "@/utils/http";

let KitchenModule = {
  getFoodList: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/list`,
      data: datas
    });
  },
  getFoodInfo: function (id) {
    return HttpRequest.getRequest({
      method: "GET",
      url: `${apiUrl}/food/info/${id}`,
    });
  },
  addFoodInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/add`,
      data: datas
    });
  },
  updateFoodInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/update`,
      data: datas
    });
  },
  deleteFoodInfo: function (id) {
    return HttpRequest.getRequest({
      method: "GET",
      url: `${apiUrl}/food/delete/${id}`,
    });
  },
  uploadFoodImg: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/upload`,
      data: datas
    });
  },
}

export {
  KitchenModule
}